import React, { useEffect, useState } from "react";
import CreateTemplates from "./CreateTemplates";
import AddButton from "../../../components/admin/usable/AddButton";
import {
  deleteTemplate,
  toggleDefault,
  viewTemplates,
} from "../../../api/admin/templateApi";
import TableLoader from "../../../components/admin/usable/TableLoader";
import SwtichButton from "../../../components/admin/usable/SwtichButton";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import EditTemplate from "./EditTemplate";

const ViewTemplates = () => {
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [Data, setData] = useState([]);
  const [EditData, setEditData] = useState(null);
  useEffect(() => {
    viewTemplates(setData);
  }, []);

  const handleToggleDefault = (item) => {
    const body = {
      id: item.id,
      templateFor: item.templateFor,
      templateName: item.templateName,
    };
    toggleDefault(setData, body);
  };
  const handleOpenEdit = (item) => {
    setEditOpen(true);
    setEditData(item);
  };

  const handleDelete = (item) => {
    const body = {
      id: item.id,
    };
    deleteTemplate(setData, body, setEditOpen);
  };
  return (
    <>
      {editOpen && (
        <EditTemplate
          setData={setData}
          editOpen={editOpen}
          setEditOpen={setEditOpen}
          EditData={EditData}
        />
      )}
      {open && (
        <CreateTemplates setData={setData} open={open} setOpen={setOpen} />
      )}
      <div className="space-y-5">
        <div className="flex justify-between items-center">
          <p className="font-bold text-black">List of Templates</p>
          <AddButton onClick={() => setOpen(true)} text="Add Templates" />
        </div>
        <div className=" w-full overflow-x-auto bg-white drop-shadow-md rounded-lg">
          <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  ID
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Template Name
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Description
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Template
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Type
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Template For
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Defualt
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  CreatedAt
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  UpdatedAt
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {Data.length > 0 ? (
                <>
                  {Data?.map((item, index) => {
                    return (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {index + 1}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.templateName}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.description}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.template.slice(0, 30)}....
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.type}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.templateFor}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          <SwtichButton
                            onChange={() => handleToggleDefault(item)}
                            checked={item.isDefault === 1}
                          />
                        </td>

                        <td className="px-4 py-3 text-sm">
                          <span
                            className={`px-2 py-1 ${
                              item.status === 1
                                ? "bg-green-100 text-green-700"
                                : "bg-red-100 text-red-700"
                            } rounded text-xs`}
                          >
                            {item.status === 1 ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.createdAt.slice(0, 10)}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.updatedAt.slice(0, 10)}
                        </td>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600 flex items-center gap-x-3">
                          <EditButton onClick={() => handleOpenEdit(item)} />
                          <DeleteButton onClick={() => handleDelete(item)} />
                        </th>
                      </tr>
                    );
                  })}
                </>
              ) : (
                <>
                  <TableLoader colSpan={11} />
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ViewTemplates;
